<i18n
  src="@/locales/views/packing_house/quality_control/query_container/list_processes.yml"
  lang="yaml"
></i18n>

<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-slate-200">
      <li
        v-for="packing_house_process in processes"
        :key="packing_house_process.id"
      >
        <div
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToListContainers(packing_house_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ packing_house_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-eye"></i>
                  <span class="space-icon"></span>{{ $t("labels.manage_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <p class="flex items-center text-sm text-gray-500">
                  <i
                    class="fa-solid fa-container-storage flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ packing_house_process.num_containers_with_inspects }} /
                  {{ packing_house_process.num_containers }}
                </p>
                <p
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                >
                  <i
                    class="fa-solid fa-box-check flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ packing_house_process.num_inspects }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import QueryContainerRequester from "@/views/packing_house/requesters/quality_control/query_container/list_processes.js";

export default {
  name: "PhQualityControlQueryContainerListProcesses",
  props: ["packing_house_id"],
  data() {
    return {
      load_data_general: false,
      processes: []
    };
  },
  methods: {
    fetchProcesses: async function () {
      let response = await QueryContainerRequester.fetchProcesses(
        this.packing_house_id
      );
      this.processes = response.data;
      this.load_data_general = true;
    },
    goToListContainers: function (packing_house_process) {
      this.$router.push({
        name: this.routeName("list_containers"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: packing_house_process.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id
        }
      }).then(() => this.fetchProcesses())
    );
  }
};
</script>
